import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { PropertyPricingService } from '@app/features/pricing-and-availability';
import { PropertyUpdateStatusComponent } from '@app/features/properties';
import { TranslocoRootModule } from '@app/transloco-root.module';
import { UiModule } from '@app/ui/ui.module';
import { map, take, tap } from 'rxjs/operators';
interface RatePlan {
  uuid: string;
  name: string;
  is_primary: boolean;
  multiple_guest_markup: {
    type: 'amount' | 'percent';
    value: number;
  };
}

interface ListingWithRatePlan {
  listing_id: string;
  name: string;
  currency: string;
  platform: string;
  picture: string;
  rate_plans: RatePlan[];
}

@Component({
  standalone: true,
  selector: 'sbnb-property-booking-rate-plans',
  templateUrl: './property-booking-rate-plans.component.html',
  styles: [``],
  imports: [CommonModule, FormsModule, UiModule, TranslocoRootModule, PropertyUpdateStatusComponent],
})
export class PropertyBookingRatePlansComponent implements OnInit {
  @Input() propertyId: any;
  @Input() propertyCurrency: string;
  @Input() propertyName: string;
  @Input() showDivider = false;

  listingsRatePlans: ListingWithRatePlan[];
  selectedRatePlans: { [key: string]: RatePlan } = {};
  hasMultipleRatePlans = false;

  // Only available to primary users
  public bookingRatePlanData$ = this.propertyPricingService.bookingRatePlanData$.pipe(
    tap((res) => {
      if (!res) {
        return;
      }
      this.listingsRatePlans = res;
      this.hasMultipleRatePlans = res.some((x) => x.rate_plans.length > 1);
      res.forEach((listing) => {
        const selectedRatePlan = listing.rate_plans.find((x) => x.is_primary);
        if (selectedRatePlan) {
          this.selectedRatePlans[listing.listing_id] = selectedRatePlan;
        }
      });
    })
  );
  public saveStatus$ = this.propertyPricingService.priceSaveState$.pipe(map((state) => state.primaryRatePlan));

  constructor(private readonly propertyPricingService: PropertyPricingService) {}

  ngOnInit(): void {
    this.bookingRatePlanData$.pipe(take(1)).subscribe();
  }

  updateRatePlan(listingId: string, event: MatSelectChange) {
    const listing = this.listingsRatePlans.find((x) => x.rate_plans.some((y) => y.uuid === event.value));
    if (listing) {
      this.selectedRatePlans[listingId] = listing.rate_plans.find((y) => y.uuid === event.value);
    }
    const payload = { ...this.selectedRatePlans[listingId], is_primary: true };
    this.propertyPricingService.saveBookingRatePlan(listingId, payload);
  }
}
